import { computed } from 'vue'

import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

export function useLoading() {
  const layoutStore = useLayoutStore()
  const { startLoading, finishLoading, loadingOperations, isLoadingOperation } = layoutStore

  const isLoading = computed(() => loadingOperations.size > 0)

  return { startLoading, finishLoading, loadingOperations, isLoading, isLoadingOperation }
}
